export * from './ReportsModule'
export const reportsPath = '/et/company/:companyId/exportModule'
